import React from 'react';

import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";

/**
 * Set plannedDate and deadline for a Requirement.
 * props:
 * element
 */
class PlannedDates extends React.Component {
  constructor(props) {
      super(props);

      this.handleDateChange = this.handleDateChange.bind(this);
      this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

      console.log("PlannedDates plannedStart:", this.props.element.plannedStart, ", deadline:", this.props.element.deadline);
      let now = new Date();
      this.state = {
          plannedStart: this.props.element.plannedStart || now,
          deadline: this.props.element.deadline || now,
          plannedStartSet: this.props.element.plannedStart ? true : false,
          deadlineSet: this.props.element.deadline ? true : false,
      }
      console.log("PlannedDates state:", this.state);
  }

  render() {
      let column1 = 4;

      return (
          <Grid container>
              <Grid item xs={12} container>
                  <Grid item xs={column1}>
                      <FormControlLabel
                          control={
                              <Checkbox
                                  name="plannedStartSet"
                                  checked={this.state.plannedStartSet}
                                  onChange={this.handleCheckboxChange}
                              />
                          }
                          label="Start"
                      />
                  </Grid>
                  <Grid item xs={12 - column1}>
                      <TextField
                          id="plannedStart"
                          type="date"
                          defaultValue={this.dateToString(this.state.plannedStart)}
                          disabled={!this.state.plannedStartSet}
                          className="date"
                          onChange={event => this.handleDateChange("plannedStart", event.target.value)}
                          InputLabelProps={{
                              shrink: true,
                          }}
                      />
                  </Grid>
              </Grid>
              <Grid item xs={12} container>
                  <Grid item xs={column1}>
                      <FormControlLabel
                          control={
                              <Checkbox
                                  name="deadlineSet"
                                  checked={this.state.deadlineSet}
                                  onChange={this.handleCheckboxChange}
                              />
                          }
                          label="Deadline"
                      />
                  </Grid>
                  <Grid item xs={12 - column1}>
                      <TextField
                          id="deadline"
                          type="date"
                          disabled={!this.state.deadlineSet}
                          defaultValue={this.dateToString(this.state.deadline)}
                          className="date"
                          onChange={event => this.handleDateChange("deadline", event.target.value)}
                          InputLabelProps={{
                              shrink: true,
                          }}
                      />
                  </Grid>
              </Grid>
          </Grid>
      );
  }

  /** Format a date to format 2020-01-31 */
  dateToString(date) {
      if(date instanceof Date) {
          return date.toISOString().split('T')[0]
      } else if(typeof date === 'string') {
          return date.split('T')[0]
      } else if(!date) {
          return date;
      } else {
          console.error("Cannot convert", date, "with type", date.constructor.name, "to date");
          return date;
      }
  }

  handleDateChange(name, value) {
      var date = new Date(value);
      console.log("handleDateChange", name, value, date);
      this.props.onChange(name, date);
  }

  handleCheckboxChange(event) {
      console.log("handleCheckboxChange", event.target.name, event.target.checked);
      this.setState({[event.target.name]: event.target.checked});

      if(event.target.name === 'plannedStartSet') {
          this.props.onChange('plannedStart', event.target.checked ? this.state.plannedStart : null);
      } else if(event.target.name === 'deadlineSet') {
          this.props.onChange('deadline', event.target.checked ? this.state.deadline : null);
      }
  }
}

export default PlannedDates;
